var map = {
	"./bird_placeholder_1.png": 51085,
	"./bird_placeholder_2.png": 37110,
	"./bird_placeholder_3.png": 34047,
	"./bird_placeholder_4.png": 82720,
	"./coral_reef.png": 32922,
	"./egypt_offshore_wind.png": 46503,
	"./egypt_onshore_wind.png": 77453,
	"./egypt_powerline_distribution.png": 26575,
	"./egypt_powerline_transmission.jpg": 20314,
	"./egypt_powerline_transmission.png": 10321,
	"./egypt_solar.png": 4039,
	"./india_offshore_wind.png": 70003,
	"./india_onshore_wind.png": 21929,
	"./india_powerline_distribution.png": 13024,
	"./india_powerline_transmission.png": 53706,
	"./india_solar.png": 76347,
	"./kenya_offshore_wind.png": 51598,
	"./kenya_onshore_wind.png": 99722,
	"./kenya_powerline_distribution.png": 89719,
	"./kenya_powerline_transmission.png": 88737,
	"./kenya_solar.png": 44670,
	"./laos_onshore_wind.png": 28205,
	"./laos_powerline_distribution.png": 31516,
	"./laos_powerline_transmission.png": 48062,
	"./laos_solar.png": 98279,
	"./mangrove.png": 71739,
	"./nepal_onshore_wind.png": 45804,
	"./nepal_powerline_distribution.png": 25169,
	"./nepal_powerline_transmission.png": 42515,
	"./nepal_solar.png": 61400,
	"./seagrass.png": 56579,
	"./thailand_offshore_wind.png": 23385,
	"./thailand_onshore_wind.png": 64359,
	"./thailand_powerline_distribution.png": 89742,
	"./thailand_powerline_transmission.png": 95408,
	"./thailand_solar.png": 36473,
	"./uzbekistan_onshore_wind.png": 32018,
	"./uzbekistan_powerline_distribution.png": 81167,
	"./uzbekistan_powerline_transmission.png": 42569,
	"./uzbekistan_solar.png": 16998,
	"./vietnam_offshore_wind.png": 57870,
	"./vietnam_onshore_wind.png": 47370,
	"./vietnam_powerline_distribution.png": 30871,
	"./vietnam_powerline_transmission.png": 12737,
	"./vietnam_solar.png": 86910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89664;